import { FormCheckboxItem } from '@/components/form/form-checkbox/FormCheckboxGroup'

export const patientsTreatedOptions: FormCheckboxItem[] = [
	{ id: 'adults', label: 'Adults' },
	{ id: 'children', label: 'Children (Pediatrics)' }
]
